import {
    GET_LIST_CUSTOMER_GROUP,
    GET_CUSTOMER_GROUP_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: [],
    active_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_GROUP: {
            return {
                ...state,
                list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_CUSTOMER_GROUP_ACTIVE: {
            return {
                ...state,
                active_list: action.payload.data,
            }
        }
        default: return { ...state };
    }
}
